<template>
  <div class="about-us">
    <s-r-m-header ref="header" activeVal='aboutUs' />
    <carousel-container ref="carouselContainer" :isLink="false" :carouselInfo="carouselInfo" />
    <CompanyDetail ref="companyDetail" @tabsChange="skipToIndustry"></CompanyDetail>
    <CompanyProfile ref="companyProfile"></CompanyProfile>
    <div class="company-history" ref="companyHistory">
      <img v-lazy="companyHistory" alt="">
    </div>
    <QualificationEnterprise ref="qualificationEnterprise"></QualificationEnterprise>
    <HonoraryAward ref="honoraryAward"></HonoraryAward>
    <ContactUs></ContactUs>
    <footer-box />
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import FooterBox from "@/components/FooterBox"
import CompanyDetail from "@/components/CompanyDetail"
import CompanyProfile from "@/components/CompanyProfile"
import QualificationEnterprise from "@/components/QualificationEnterprise"
import HonoraryAward from "@/components/HonoraryAward"
import ContactUs from "@/components/ContactUs"
import { baiduConsult } from "./common.js";
import hgs4 from '@/assets/images/hgs4.png'
import companyHistory from '@/assets/images/company-history.png'
export default {
  components: {
    SRMHeader,
    CarouselContainer,
    CompanyDetail,
    CompanyProfile,
    FooterBox,
    QualificationEnterprise,
    HonoraryAward,
    ContactUs
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      companyHistory,
      carouselInfo: {
        title: '关于璞华',
        description: '帮助企业实现数智化转型升级',
        bg: hgs4
      },
      // #f0f2f5
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
    skipToIndustry(item) {
      const carouselContainerH = this.$refs.carouselContainer.$el.clientHeight
      const companyDetailH = this.$refs.companyDetail.$el.clientHeight
      const companyProfileH = this.$refs.companyProfile.$el.clientHeight
      const companyHistoryH = this.$refs.companyHistory.clientHeight 
      const qualificationEnterpriseH = this.$refs.qualificationEnterprise.$el.clientHeight
      const honoraryAward = this.$refs.honoraryAward.$el.clientHeight
      
      let top = 0
      if(item === 'companyProfile') {
        top = carouselContainerH + companyDetailH
      } else if(item === 'enterpriseQualification') {
        top = carouselContainerH + companyDetailH + companyProfileH + companyHistoryH
      } else if(item === 'contactus') {
        top = carouselContainerH + companyDetailH + companyProfileH + companyHistoryH + qualificationEnterpriseH + honoraryAward
      } else {
        return
      }
      window.scrollTo({
        top,
        left: 0,
        behavior: "smooth"
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.about-us {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .srm-carousel-box {
    .carousel-box {
      padding: 17.3rem 0 17.2rem 26rem;
      .content {
        margin-bottom: 0;
      }
    }
  }
  .company-history {
    height: 81rem;
    img {
      width: 100%;
      height: 81rem;
    }
  }
}

@include mobile {
  .about-us {
    ::v-deep .srm-header {
      padding-right: 1.6rem;
    }
    ::v-deep .srm-carousel-box .carousel-box {
      padding: 6.4rem 1.6rem 4.4rem;
    }
    .company-history {
      height: auto;
      img {
        height: auto;
      }
    }
  }
}
</style>
